// e.g. '04.12.2023'
export function getLocalString(dateString = '', options = {}, locale = 'ru') {
    if (!Date.parse(dateString)) return '';

    return new Date(dateString).toLocaleString(locale, options);
}
